import { getUserInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: null,
  selectedDocId: null,
  selectedDocName: null
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_INFO: (state, info) => {
    state.userInfo = info
  },
  SET_SELECTED_DOC_ID: (state, id) => {
    state.selectedDocId = id
  },
  SET_SELECTED_DOC_NAME: (state, name) => {
    state.selectedDocName = name
  }
}

const actions = {
  // 获取用户信息
  getUserInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      getUserInfo(payload)
        .then(res => {
          commit('SET_INFO', res.data)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // remove token
  resetToken({ commit, dispatch }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_INFO', {})
      removeToken()
      resolve()
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
